export const foodCalculators = [

  // pizza
  {
    name: "Calculatrice à Pizza",
    link: "/calculator/fr/pizza/",
    description:
      "Calculatrice de pizza gratuite - calcule la quantité de pâte, de sauce et de fromage pour n'importe quelle taille. Spécifiez la taille et le nombre de parts et obtenez la formule exacte immédiatement.",
    showMain: true,
  },
  // 
  {
    name: "Calculatrice Crème Glacée",
    link: "/calculator/fr/ice-cream/",
    description:
      "Calcule la quantité d'ingrédients nécessaires pour fabriquer une délicieuse crème glacée à la maison. La calculatrice de crème glacée vous aide à déterminer la quantité de lait, sucre, crème et saveurs requises en fonction du nombre de portions que vous souhaitez préparer.",
    showMain: true,
  },
  //  cake-pan-conversion
  {
    name: "Calculatrice Conversion Moules à Gâteau",
    link: "/calculator/fr/cake-pan-conversion/",
    description:
      "Convertissez facilement les tailles de moules à gâteau. La calculatrice de conversion de moules à gâteau vous aide à connaître la taille de moule appropriée en fonction des différentes mesures, que vous utilisiez un moule rond, carré ou rectangulaire.",
    showMain: true,
  },
  // perfect-pancake
  {
    name: "Calculatrice Crêpe Parfaite",
    link: "/calculator/fr/perfect-pancake/",
    description:
      "Obtenez la recette de crêpe parfaite en fonction du nombre de portions que vous souhaitez préparer. La calculatrice de crêpe parfaite vous aide à déterminer la quantité d'ingrédients nécessaires tels que la farine, le lait, les œufs et le sucre pour obtenir des résultats délicieux et parfaits.",
    showMain: true,
  },
  // grams-to-cups
  {
    name: "Calculatrice Grammes en Tasses",
    link: "/calculator/fr/grams-to-cups/",
    description:
      "Convertissez facilement les grammes en tasses. La calculatrice grammes en tasses vous aide à connaître la quantité d'ingrédients dont vous avez besoin en fonction du poids, ce qui facilite la préparation précise de vos recettes préférées.",
    showMain: true,
  },
  {
    name: "Calculatrice Valeur Nutritionnelle des Aliments",
    link: "/calculator/fr/food-nutrients-calculator/",
    description:
      "Calculez facilement la valeur nutritionnelle des aliments. La calculatrice de valeur nutritionnelle des aliments vous aide à connaître la quantité de calories, protéines, lipides et glucides dans vos plats préférés, ce qui vous aide à prendre des décisions alimentaires saines.",
    showMain: true,
  },
  // cooking-measurement
  {
    name: "Calculatrice Conversion Mesures Cuisson",
    link: "/calculator/fr/cooking-measurement/",
    description:
      "Convertissez facilement les mesures de cuisson. La calculatrice de conversion de mesures de cuisson vous aide à connaître la quantité d'ingrédients dont vous avez besoin en fonction de différentes unités de mesure, ce qui facilite la préparation précise de vos recettes préférées.",
    showMain: true,
  },
  // chocolate-calculator
  {
    name: "Calculatrice Chocolat",
    link: "/calculator/fr/chocolate-calculator/",
    description:
      "Calculez la quantité de chocolat nécessaire pour fabriquer de délicieuses friandises. La calculatrice de chocolat vous aide à déterminer la quantité de chocolat requise en fonction du nombre de portions que vous souhaitez préparer, ce qui facilite l'obtention de résultats délicieux et parfaits.",
  },
  // donut
  {
    name: "Calculatrice Beignets",
    link: "/calculator/fr/donut/",
    description:
      "Calculez la quantité d'ingrédients nécessaires pour fabriquer de délicieux beignets à la maison. La calculatrice de beignets vous aide à déterminer la quantité de farine, sucre, levure et sel requises en fonction du nombre de portions que vous souhaitez préparer.",
  },

];
export default foodCalculators;
